import { createSelector } from 'reselect';

const selectCategoriess = (state: any) => state.categories;


export const selectCategoriesCurrentItem = createSelector([selectCategoriess], (categories) => categories.current);

export const selectCategoriesListItems = createSelector([selectCategoriess], (categories) => categories.list);

export const selectCategoryItemById = (itemId: any) =>
    createSelector(selectCategoriesListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectCategoryQueryItems = createSelector([selectCategoriess], (categories) => categories.query);

export const selectCategoryCreatedItem = createSelector([selectCategoriess], (categories) => categories.create);

export const selectCategoryUpdatedItem = createSelector([selectCategoriess], (categories) => categories.update);

export const selectCategoryReadItem = createSelector([selectCategoriess], (categories) => categories.read);

export const selectCategoryDeletedItem = createSelector([selectCategoriess], (categories) => categories.delete);

export const selectCategorySearchedItems = createSelector([selectCategoriess], (categories) => categories.search);

export const selectCategoryItemsCount = createSelector([selectCategoriess], (categories) => categories.count);

export const selectCategoryItemsFilter = createSelector([selectCategoriess], (categories) => categories.filter);